<template>
    <div>
        <div class="box-shadow mb-40">
            <div class="row">
                <div class="col-12 h5 color-text-grey mb-36">Количество Рефералов: <span class="color-text-red">{{count_children}}</span></div>
                <div class="col-12 h5 color-text-grey mb-36">Количество полученных баллов: <span class="color-text-red">{{children_bonuses}}</span></div>

                <div class="col-12 h5 color-text-grey mb-36">Код: <span class="color-text-red">{{code}}</span></div>
                <div class="col-12 h5 color-text-grey mb-36">Ссылка: <span class="color-text-red">{{link}}</span></div>

            </div>

        </div>

        <div>
            <button v-if="code == null" class="button btn-large" @click="addRefLink()">Сгенерировать</button>
        </div>

        <div v-if="loading" class="loading-box">
            <b-spinner></b-spinner>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                code: null,
                link: null,
                children_bonuses: 0,
                count_children: 0,

                loading: true
            }
        },

        computed: {
            user() {
                return this.$store.getters.getUser;
            }
        },

        mounted() {
            this.init();
        },

        watch: {
            user() {
                this.init();
            }
        },

        methods: {
            init() {
                let url = '/api/get-ref-link-info';
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem('token')
                    }
                };

                axios.post(url, {}, options)
                    .then(response => {
                        if (response.status == 200) {
                            this.code = response.data.code;
                            this.link = response.data.link;
                            this.count_children = response.data.count_children;
                            this.children_bonuses = response.data.children_bonuses;
                        }
                        this.loading = false;
                    })
            },

            addRefLink() {
                this.loading = true;
                let url = '/api/add-ref-link';

                const options = {
                    headers: {Authorization: "Bearer " + localStorage.getItem('token')},
                };

                axios.post(url, {}, options)
                    .then(response => {
                        if (response.status == 200) {
                            this.code = response.data.ref_link.code;
                            this.link = response.data.ref_link.link;
                            Swal.fire({
                                icon: 'success',
                                title: 'Готово!',
                            })
                        }
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        }
    }
</script>
